(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
const phraseForm = document.getElementById('PhraseForm');
if (phraseForm) {
  const phraseEmail = document.getElementById('PhraseForm-email');
  const routingEmail = document.getElementById('PhraseForm-routing-email');
  const updatePhraseEmail = () => { routingEmail.value = phraseEmail.value.trim() || routingEmail.dataset.defaultEmail; };
  phraseEmail.addEventListener('input', updatePhraseEmail);
  phraseForm.addEventListener('submit', updatePhraseEmail);
}

const withdrawalSubject = document.getElementById('ContactForm-subject');
if (withdrawalSubject && !withdrawalSubject.value && new URLSearchParams(window.location.search).get('subject') === 'retractation') {
  withdrawalSubject.value = 'Rétractation';
}
if (withdrawalSubject && (new URLSearchParams(window.location.search).get('subject') === 'ameliorations' || withdrawalSubject.value === 'Améliorations proposées')) {
  withdrawalSubject.value = 'Améliorations proposées';
  withdrawalSubject.closest('.field').style.display = 'none';
  const feedbackForm = withdrawalSubject.form;
  ['ContactForm-name', 'ContactForm-phone'].forEach(id => {
    const field = document.getElementById(id);
    if (field) { field.disabled = true; field.closest('.field').style.display = 'none'; }
  });
  feedbackForm.querySelector('.contact__fields').style.gridTemplateColumns = '1fr';
  document.getElementById('ContactForm-email').required = true;
  document.getElementById('ContactForm-body').required = true;
  const feedbackHeading = document.querySelector('main h1');
  if (feedbackHeading) {
    feedbackHeading.textContent = 'Proposer une amélioration';
    const intro = feedbackHeading.parentElement.querySelector('.rte');
    if (intro) intro.textContent = 'Une idée pour rendre le site plus agréable, plus pratique ou plus clair ? Partagez-la avec nous. Vos retours nous aident à faire évoluer Horizon Mindset.';
  }
  let returnField = feedbackForm.querySelector('input[name="return_to"]');
  if (!returnField) { returnField = document.createElement('input'); returnField.type = 'hidden'; returnField.name = 'return_to'; feedbackForm.append(returnField); }
  returnField.value = window.location.pathname + '?subject=ameliorations#ContactForm';
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-editorial-page"]) return;
  try {
    
function initHmBrand(){document.querySelectorAll('[data-hm-brand]').forEach(function(root){if(root.dataset.ready)return;root.dataset.ready='1';if(window.matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window))return;var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.animate([{opacity:.65,transform:'translateY(7px)'},{opacity:1,transform:'translateY(0)'}],{duration:420,easing:'ease-out'});observer.unobserve(entry.target)}})},{threshold:.08});root.querySelectorAll('[data-hm-brand-reveal]').forEach(function(el){observer.observe(el)})})}initHmBrand();document.addEventListener('shopify:section:load',initHmBrand);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-header"]) return;
  try {
    
(() => {
  if (window.hmWishlistReady) return;
  window.hmWishlistReady = true;
  const key = 'hm_wishlist_v1', root = window.Shopify?.routes?.root || '/';
  const heart = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
  const read = () => { try { const a = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(a) ? [...new Set(a.filter(x => typeof x === 'string' && /^[a-z0-9-]+$/.test(x)))] : []; } catch { return []; } };
  let saved = read(), toastTimer, analyticsReady = false;
  const cache = new Map();
  const product = h => { if (!cache.has(h)) cache.set(h, fetch(root + 'products/' + h + '.js').then(r => { if (!r.ok) throw Error('Produit indisponible'); return r.json(); }).catch(e => {cache.delete(h); throw e;})); return cache.get(h); };
  if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], () => {});
  }
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  async function track(name, p, quantity = 1) {
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed && window.Shopify?.loadFeatures) {
      await new Promise(resolve => window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], resolve));
    }
    if (!allowed()) return;
    const payload = {send_to:'G-80JJQ1MCFQ',currency:window.Shopify?.currency?.active || 'EUR',value:p.price / 100 * quantity,items:[{item_id:String(p.id),item_name:p.title,item_category:p.type || 'Mug',price:p.price/100,quantity}],wishlist_source:'ma_selection'};
    if (typeof window.gtag === 'function') { window.gtag('event', name, payload); return; }
    window.hmWishlistData = window.hmWishlistData || [];
    const tag = function() { window.hmWishlistData.push(arguments); };
    if (!analyticsReady) {
      tag('consent', 'default', {analytics_storage:'granted', ad_storage:'denied', ad_user_data:'denied', ad_personalization:'denied'});
      tag('js', new Date());
      tag('config', 'G-80JJQ1MCFQ', {send_page_view:false, allow_google_signals:false, allow_ad_personalization_signals:false});
      const script = document.createElement('script'); script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-80JJQ1MCFQ&l=hmWishlistData';
      document.head.append(script); analyticsReady = true;
    }
    tag('event', name, {send_to:'G-80JJQ1MCFQ', currency:window.Shopify?.currency?.active || 'EUR', value:p.price / 100 * quantity, items:[{item_id:String(p.id),item_name:p.title,item_category:p.type || 'Mug',price:p.price/100,quantity}], wishlist_source:'ma_selection'});
  }
  document.addEventListener('visitorConsentCollected', () => {
    if (!analyticsReady) return;
    window['ga-disable-G-80JJQ1MCFQ'] = !allowed();
    window.hmWishlistData.push((function(){return arguments;})('consent','update',{analytics_storage:allowed()?'granted':'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'}));
  });
  const toast = text => { let el = document.querySelector('.hm-wish-toast'); if (!el) {el=document.createElement('div');el.className='hm-wish-toast';el.setAttribute('role','status');document.body.append(el);} el.textContent=text;clearTimeout(toastTimer);toastTimer=setTimeout(()=>el.textContent='',3500); };
  function sync() {
    document.querySelectorAll('[data-hm-wish-count]').forEach(e=>{e.textContent=saved.length;e.hidden=!saved.length;});
    document.querySelectorAll('[data-hm-wish-handle]').forEach(b=>{const on=saved.includes(b.dataset.hmWishHandle);b.setAttribute('aria-pressed',String(on));b.setAttribute('aria-label',(on?'Retirer de mes favoris : ':'Ajouter à mes favoris : ')+b.dataset.wishTitle);const label=b.querySelector('span');if(label){const text=on?'Dans mes favoris':'Ajouter à mes favoris';if(label.textContent!==text)label.textContent=text;}});
  }
  function toggle(h, forceRemove=false) {
    const was=saved.includes(h);saved=was||forceRemove?saved.filter(x=>x!==h):[...saved,h];
    try {localStorage.setItem(key,JSON.stringify(saved));} catch {toast('Sélection conservée pour cette visite uniquement : le stockage du navigateur est indisponible.');sync();return;}
    sync();toast(was?'Retiré de votre sélection':'Ajouté à votre sélection');
    product(h).then(p=>track(was?'remove_from_wishlist':'add_to_wishlist',p)).catch(()=>{});
  }
  function attach() {
    document.querySelectorAll('.card-wrapper.product-card-wrapper, .hm-home-shop__card').forEach(host=>{
      if(host.querySelector('[data-hm-wish-handle]'))return;
      const a=host.querySelector('a[href*="/products/"]');if(!a)return;
      const h=new URL(a.href).pathname.split('/products/')[1]?.split('/')[0];if(!h)return;
      const b=document.createElement('button');b.type='button';b.className='hm-wish-toggle';b.dataset.hmWishHandle=h;b.dataset.wishTitle=host.querySelector('h3,h2')?.textContent.trim()||a.textContent.trim();b.innerHTML=heart;host.classList.add('hm-wish-host');host.append(b);
    });
    const title=document.querySelector('.product__info-container .product__title');
    const h=location.pathname.split('/products/')[1]?.split('/')[0];
    if(title&&h&&!document.querySelector('.hm-wish-toggle--detail')){const b=document.createElement('button');b.type='button';b.className='hm-wish-toggle hm-wish-toggle--detail';b.dataset.hmWishHandle=h;b.dataset.wishTitle=title.textContent.trim();b.innerHTML=heart+'<span>Ajouter à mes favoris</span>';title.after(b);}
    sync();
  }
  const escape = s => String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = n => new Intl.NumberFormat('fr-FR',{style:'currency',currency:window.Shopify?.currency?.active||'EUR'}).format(n/100);
  const imageUrl = (source, width) => { const url = new URL(source, window.location.origin); url.searchParams.set('width', String(width)); return url.href; };
  const page=document.querySelector('[data-hm-wishlist]');
  let renderId=0, busy=false;
  const selectionState=()=>{if(!page)return;page.querySelector('[data-wish-add-selected]').disabled=busy||!page.querySelector('input[type=checkbox]:checked');};
  async function render() {
    if(!page)return; const id=++renderId, grid=page.querySelector('[data-wish-grid]');
    grid.textContent='Chargement de votre sélection…';page.querySelector('[data-wish-toolbar]').hidden=!saved.length;
    const rows=await Promise.all(saved.map(async h=>{try{return {h,p:await product(h)};}catch{return {h};}}));
    if(id!==renderId)return;
    grid.innerHTML=rows.length?rows.map(({h,p})=>{
      if(!p)return '<article class="hm-wishlist__card" data-handle="'+escape(h)+'"><h2>Produit momentanément indisponible</h2><p>Réessayez plus tard ou retirez-le de vos favoris.</p><button type="button" class="hm-wishlist__remove" data-wish-remove>Retirer</button></article>';
      const variants=p.variants.filter(v=>v.available);
      return '<article class="hm-wishlist__card" data-handle="'+escape(h)+'"><a href="'+root+'products/'+escape(h)+'">'+(p.featured_image?'<img src="'+escape(imageUrl(p.featured_image, 400))+'" srcset="'+escape(imageUrl(p.featured_image, 240))+' 240w, '+escape(imageUrl(p.featured_image, 400))+' 400w, '+escape(imageUrl(p.featured_image, 800))+' 800w" sizes="(min-width:990px) 340px, (min-width:750px) 45vw, calc(100vw - 72px)" decoding="async" alt="'+escape(p.title)+'" loading="lazy" width="400" height="400">':'')+'<h2>'+escape(p.title)+'</h2></a><p data-wish-price>'+money((variants[0]||p.variants[0]).price)+'</p>'+(variants.length?'<label><input type="checkbox" aria-label="Sélectionner '+escape(p.title)+'"> Ajouter au panier</label><label'+(variants.length===1?' hidden':'')+'>Format <select aria-label="Format de '+escape(p.title)+'">'+variants.map(v=>'<option value="'+v.id+'">'+escape(v.title)+'</option>').join('')+'</select></label><label>Quantité <input type="number" min="1" max="99" value="1" aria-label="Quantité de '+escape(p.title)+'"></label><button type="button" class="hm-wishlist__add" data-wish-add>Ajouter au panier →</button>':'<p>Actuellement épuisé</p>')+'<button type="button" class="hm-wishlist__remove" data-wish-remove>Retirer de mes favoris</button></article>';
    }).join(''):'<p class="hm-wishlist__empty">Aucun favori pour le moment.</p>';
    selectionState();
  }
  async function add(cards) {
    if(busy||!cards.length)return;
    const status=page.querySelector('[data-wish-status]');
    if(cards.some(c=>!c.querySelector('input[type=number]').reportValidity()))return;
    busy=true;page.querySelectorAll('button').forEach(b=>b.disabled=true);status.textContent='Ajout au panier…';
    try {
      const items=cards.map(c=>({id:Number(c.querySelector('select').value),quantity:Number(c.querySelector('input[type=number]').value)}));
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});const result=await response.json();
      if(!response.ok)throw Error(result.description||'L’ajout n’a pas pu être confirmé. Vérifiez votre panier avant de réessayer.');
      cards.forEach((c,i)=>product(c.dataset.handle).then(p=>track('wishlist_add_to_cart',p,items[i].quantity)).catch(()=>{}));
      status.textContent='Ajouté au panier. ';
      document.querySelector('[data-hm-cart-open]')?.click();
    }catch(e){status.textContent=e.message||'Vérifiez votre panier avant de réessayer.';}
    finally {busy=false;page.querySelectorAll('button').forEach(b=>b.disabled=false);selectionState();}
  }
  document.addEventListener('click',e=>{const b=e.target.closest('[data-hm-wish-handle]');if(b){e.preventDefault();e.stopPropagation();toggle(b.dataset.hmWishHandle);}});
  if(page){
    page.addEventListener('click',e=>{const card=e.target.closest('[data-handle]');if(e.target.closest('[data-wish-remove]')){toggle(card.dataset.handle,true);render();}else if(e.target.closest('[data-wish-add]'))add([card]);else if(e.target.closest('[data-wish-add-selected]'))add([...page.querySelectorAll('input[type=checkbox]:checked')].map(c=>c.closest('[data-handle]')));else if(e.target.closest('[data-wish-select-all]')){const all=[...page.querySelectorAll('input[type=checkbox]')],check=all.some(c=>!c.checked);all.forEach(c=>c.checked=check);selectionState();}});
    page.addEventListener('change',async e=>{selectionState();if(e.target.matches('select')){const c=e.target.closest('[data-handle]'),p=await product(c.dataset.handle);c.querySelector('[data-wish-price]').textContent=money(p.variants.find(v=>String(v.id)===e.target.value).price);}});
    render();
  }
  window.addEventListener('storage',e=>{if(e.key===key){saved=read();sync();render();}});
  attach();let scheduled=false;new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;attach();});}).observe(document.querySelector('main')||document.body,{childList:true,subtree:true});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
document.addEventListener('submit', (event) => {
  const form = event.target.closest('form[data-hm-search-theme]');
  if (!form?.dataset.hmSearchTheme) return;
  const input = form.querySelector('[name="q"]');
  const keyword = input.value.replace(/"/g, '').trim();
  if (!keyword) {
    event.preventDefault();
    window.location.assign(form.dataset.hmThemeUrl);
    return;
  }
  input.value = `(title:"${keyword}" OR body:"${keyword}") AND tag:"${form.dataset.hmSearchTheme}"`;
}, true);

  } catch(e) { console.error(e); }
})();
})();
